import { libraryManagedConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export const addToGroup = (data: { productGroupId: number; productId: string }) => {
    const { productGroupId, productId } = data;
    return http
        .put(
            libraryManagedConfig().endpointProductGroupBulkSource,
            { productIds: [productId] },
            {
                pathParams: { productGroupId, source: 'cc', kind: 'ids', action: 'copy' }
            }
        )
        .then(res => res.data);
};
